import { useMemo, useState } from "react";

import { getSidebarContent } from "../contentful";

const promise = getSidebarContent();

export default function useSidebar() {
  const [content, setContent] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useMemo(() => {
    promise.then((content) => {
      setContent(content.items[0].fields.sidebarContent);
      setLoading(false);
    });
  }, []);

  return [content, isLoading];
}
